import { ChevronLeftIcon, XMarkIcon } from '@heroicons/react/24/outline';
import Button from 'components/gruenland/atoms/button/Button';
import Typography from 'components/gruenland/atoms/typography';
import { useFormat } from 'helpers/hooks/useFormat';
import { Category } from 'types/entity/category';
import HeaderLogo from '../../../header-logo';

export interface Props {
  categories: Category[];
  onArrowClick: () => void;
  hideHeaderMenu: () => void;
}

const MobileMenuHeader: React.FC<Props> = ({ onArrowClick, hideHeaderMenu, categories }) => {
  const { formatMessage } = useFormat({ name: 'gruenland' });
  return (
    <div className="pb-2">
      <div className="flex w-full items-center justify-between border-b border-neutral-400 px-5 py-3">
        <HeaderLogo onClick={hideHeaderMenu} />
        <Button
          variant="ghost"
          size="xs"
          onClick={hideHeaderMenu}
          title={formatMessage({ id: 'common.close', defaultMessage: 'Chiudi' })}
        >
          <XMarkIcon className="w-6 text-secondary-black" />
        </Button>
      </div>
      {categories.length > 0 && (
        <div className="mt-3 px-5">
          <Button variant="buttonLink" onClick={onArrowClick}>
            <ChevronLeftIcon className="w-5 text-secondary-black" />{' '}
          </Button>
        </div>
      )}
      {categories.length > 0 && (
        <div className="mt-2 px-5">
          <Typography className="font-bold">{categories[categories.length - 1].name}</Typography>
        </div>
      )}
    </div>
  );
};

export default MobileMenuHeader;
